export default __webpack_public_path__ + "static/media/contact-3.a6ee4077.png";